<template lang="html">
  <div class="modal start" style="position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 998; display: table; transition: opacity 0.3s ease 0s; opacity: 1;">
    <div class="modal-wrapper" style="display: table-cell; vertical-align: middle;">
      <div class="modal-container" style="margin: 0px auto; max-width: 780px; background-color: rgba(41, 54, 61, 0.95); border-radius: 2px; box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 8px; padding: 20px 30px; transition: all 0.3s ease 0s; max-height: 100%; overflow: auto; position: relative; word-break: break-word;">
        <h2 class="title controls-group">
          <span>{{$localizer('Generate Dungeon')}}</span>
          <button type="button" class="close-btn" @click="close()">X</button>
        </h2>
        <div class="content controls-group">
          <div>
            <label>Type</label>
            <select v-model="type">
              <optgroup label="Maze">
                <option>DividedMaze</option>
                <option>IceyMaze</option>
                <option>EllerMaze</option>
              </optgroup>
              <optgroup label="Cellular">
                <option>Cellular</option>
              </optgroup>
              <optgroup label="Dungeon">
                <option>Digger</option>
                <option>Uniform</option>
                <option>Rogue</option>
              </optgroup>
            </select>
          </div>
          <div class="tile-selector">
            <div>
              <label>Tile O</label>
              <select v-model="tileO.tilesetId" @change="tileO.tileIndex = -1">
                <option :value="null">Select tileset</option>
                <option v-for="file in tilesets" :key="file.id" :value="file.id">{{file.name}}</option>
              </select>
              <TileList :tilesetId="tileO.tilesetId" :tileIndex="tileO.tileIndex" :emptyTile="true" @change="tileO.tileIndex = $event.tileIndex" />
            </div>
            <div>
              <label>Tile X</label>
              <select v-model="tileX.tilesetId" @change="tileX.tileIndex = -1">
                <option :value="null">Select tileset</option>
                <option v-for="file in tilesets" :key="file.id" :value="file.id">{{file.name}}</option>
              </select>
              <TileList :tilesetId="tileX.tilesetId" :tileIndex="tileX.tileIndex" :emptyTile="true" @change="tileX.tileIndex = $event.tileIndex" />
            </div>
          </div>
          <div style="text-align: right;margin-top: 20px;">
            <button type="button" class="btn-flat" @click="close()">cancel</button>
            <button type="button" class="btn-flat" @click="confirm()">ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GameStudio from '@/assets/js/GameStudio.js'
import TileList from '@/assets/components/tileset/TileList.vue'

export default {
  components: {
    TileList
  },
  data() {
    return {
      tilesets: GameStudio.getFilesWithExtensions(['.tileset']),
      type: 'DividedMaze',
      tileO: {
        tilesetId: null,
        tileIndex: -1
      },
      tileX: {
        tilesetId: null,
        tileIndex: -1
      }
    };
  },
  methods: {
    close() {
      this.$el.classList.add('close');
      this.$el.style.opacity = 0;
			setTimeout(() => {
				this.$emit('close');
			}, 300);
    },
    toTilePayload(tile) {
      if (!tile.tilesetId || tile.tileIndex == -1) return 0;
      return [tile.tilesetId, tile.tileIndex];
    },
    confirm() {
      if (!this.tileO.tilesetId || this.tileO.tileIndex == -1) return;
      this.$emit('confirm', {
        type: this.type,
        tileO: this.toTilePayload(this.tileO),
        tileX: this.toTilePayload(this.tileX)
      });
      this.close();
    }
  }
}
</script>

<style lang="css" scoped>
.modal .btn {
	border: none;
	background: none;
	color: inherit;
	cursor: pointer;
	opacity: 0.5;
	transition: opacity 0.4s;
	outline: none;
	border: 1px solid #ccc;
	padding: 5px 12px;
  border-radius: 2px;
}
.modal .btn:hover {
	opacity: 1;
}

.modal .close-btn {
	border: none;
	background: none;
	float: right;
	display: block;
	color: inherit;
	font-size: inherit;
	cursor: pointer;
	opacity: 0.5;
	transition: opacity 0.4s;
	outline: none;
}
.modal .close-btn:hover {
	opacity: 1;
}

.tile-selector {
  display: flex;
  margin-top: 20px;
}
.tile-selector > div {
  width: 50%;
}
.tile-selector > div:first-child {
  margin-right: 20px;
}
.tile-selector label {
  margin-bottom: 5px;
}
</style>
